import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonRoundRegular from './person-round-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonRoundRegular {...validProps} />;
}

SvgComponent.iconName = 'person-round-regular';

export const PersonRoundRegularIcon = svgIconWrapper(SvgComponent);
